import { SVGProps, useId } from 'react'

const Web = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.334a16.667 16.667 0 1 0 0 33.333 16.667 16.667 0 0 0 0-33.333"
			fill="#FE8C25"
		/>
		<path
			d="M19.75 10.002c-2.804.062-5.728 1.294-7.758 4.024-3.288 4.422-2.42 10.537 1.975 13.92A9.8 9.8 0 0 0 19.987 30c2.218 0 4.307-.744 5.806-1.953l.02.024.653-.574-2.212-2.52-.921.846c-.487.444-.957.872-1.414 1.313-.74-.845-1.49-1.681-2.239-2.517l-1.142-1.283 1.055-.987-2.718-3.071 1.064-.998-2.762-3.077 3.76-3.399 1.389 1.503 2.3-2.044.058.019 1.317 1.443 1.23-1.127s-.325-.303-.647-.479a.3.3 0 0 0-.138-.034c-1.376-.735-3.015-1.12-4.696-1.083m6.204 2.268-1.099 1.006.991 1.1 1.104-.992zm-3.344.297-1.7 1.545 1.529 1.7 1.697-1.534zm-3.78.625-2.293 2.078 2.069 2.302 2.297-2.075zm8.64 2.637-1.096.998 1 1.106 1.104-1.002zm-3.216.349-1.698 1.54 1.529 1.706 1.701-1.54zm-3.719 1.097-2.293 2.083 2.073 2.302 2.286-2.08zm8.463 2.11-1.102.992 1 1.106L30 20.489zm-3.217.587-1.697 1.535 1.53 1.71 1.7-1.543zm-3.552 1.44-2.292 2.075L22 25.795l2.301-2.078zm5.116 2.185-1.69 1.542 1.532 1.697 1.702-1.536z"
			fill="#fff"
		/>
	</svg>
)

const Facebook = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 4.167a15.833 15.833 0 1 0 0 31.666 15.833 15.833 0 0 0 0-31.666"
			fill="#039BE5"
		/>
		<path
			d="M22.143 24.197h4.098l.643-4.163h-4.742V17.76c0-1.729.565-3.262 2.183-3.262h2.599v-3.633c-.457-.062-1.423-.197-3.248-.197-3.81 0-6.045 2.013-6.045 6.598v2.77h-3.917v4.162h3.917v11.44c.776.117 1.562.196 2.369.196.729 0 1.44-.066 2.143-.161z"
			fill="#fff"
		/>
	</svg>
)

const Instagram = (props: SVGProps<SVGSVGElement>) => {
	const id = useId()

	return (
		<svg
			width={40}
			height={40}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle
				cx={19.995}
				cy={19.995}
				r={16.665}
				fill={`url(#instagram-gradient-${id})`}
			/>
			<path
				d="M20 24.846A4.85 4.85 0 0 1 15.154 20 4.85 4.85 0 0 1 20 15.154 4.85 4.85 0 0 1 24.848 20 4.85 4.85 0 0 1 20 24.846m0-8.308A3.466 3.466 0 0 0 16.54 20 3.465 3.465 0 0 0 20 23.462 3.465 3.465 0 0 0 23.463 20 3.466 3.466 0 0 0 20 16.538m5.193-.691a1.038 1.038 0 1 0 0-2.077 1.038 1.038 0 0 0 0 2.077"
				fill="#fff"
			/>
			<path
				d="M24.154 29h-8.308A4.85 4.85 0 0 1 11 24.154v-8.308A4.85 4.85 0 0 1 15.846 11h8.308A4.85 4.85 0 0 1 29 15.846v8.308A4.85 4.85 0 0 1 24.154 29m-8.308-16.615a3.466 3.466 0 0 0-3.461 3.461v8.308a3.466 3.466 0 0 0 3.461 3.461h8.308a3.466 3.466 0 0 0 3.461-3.461v-8.308a3.466 3.466 0 0 0-3.461-3.461z"
				fill="#fff"
			/>
			<defs>
				<radialGradient
					id={`instagram-gradient-${id}`}
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(15.72 36.684)scale(41.5471)"
				>
					<stop stopColor="#FD5" />
					<stop offset={0.328} stopColor="#FF543F" />
					<stop offset={0.348} stopColor="#FC5245" />
					<stop offset={0.504} stopColor="#E64771" />
					<stop offset={0.643} stopColor="#D53E91" />
					<stop offset={0.761} stopColor="#CC39A4" />
					<stop offset={0.841} stopColor="#C837AB" />
				</radialGradient>
			</defs>
		</svg>
	)
}

const Twitter = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.205-7.446 16.674-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.343 19.983 3.334c9.205-.01 16.674 7.446 16.683 16.65"
			fill="#03A9F4"
		/>
		<path
			d="M28.997 14.714a7.5 7.5 0 0 1-2.123.581 3.7 3.7 0 0 0 1.625-2.028 7.4 7.4 0 0 1-2.346.887A3.7 3.7 0 0 0 23.46 13c-2.04 0-3.694 1.639-3.694 3.66q.001.429.097.835a10.52 10.52 0 0 1-7.612-3.827 3.65 3.65 0 0 0 1.142 4.89 3.76 3.76 0 0 1-1.674-.456v.043c0 1.775 1.274 3.253 2.962 3.59a3.7 3.7 0 0 1-.97.131c-.24 0-.472-.027-.697-.067a3.7 3.7 0 0 0 3.45 2.543 7.46 7.46 0 0 1-5.468 1.514A10.55 10.55 0 0 0 16.66 27.5c6.792 0 10.507-5.578 10.507-10.416q0-.239-.012-.473a7.3 7.3 0 0 0 1.843-1.896"
			fill="#fff"
		/>
	</svg>
)

const Whatsapp = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={19.995} cy={19.995} r={16.665} fill="#40C351" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m10.496 29.503 1.337-4.88a9.4 9.4 0 0 1-1.258-4.709c.003-5.193 4.228-9.418 9.422-9.418a9.36 9.36 0 0 1 6.664 2.762 9.36 9.36 0 0 1 2.757 6.664c-.002 5.192-4.229 9.418-9.421 9.418h-.004a9.4 9.4 0 0 1-4.502-1.147z"
			fill="#fff"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.496 29.751a.247.247 0 0 1-.24-.313l1.31-4.781a9.67 9.67 0 0 1-1.239-4.742c.002-5.33 4.34-9.667 9.67-9.667a9.6 9.6 0 0 1 6.84 2.835 9.6 9.6 0 0 1 2.83 6.839c-.003 5.33-4.34 9.666-9.67 9.666a9.7 9.7 0 0 1-4.538-1.13l-4.9 1.285a.2.2 0 0 1-.063.008"
			fill="#fff"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.536 14.383A7.78 7.78 0 0 0 20 12.087c-4.32 0-7.832 3.511-7.834 7.827 0 1.48.413 2.92 1.197 4.167l.187.296-.792 2.889 2.965-.777.286.17a7.8 7.8 0 0 0 3.985 1.09h.003c4.317 0 7.83-3.511 7.831-7.828a7.78 7.78 0 0 0-2.292-5.538"
			fill="#40C351"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.641 15.977c-.176-.392-.362-.4-.53-.407-.137-.006-.294-.005-.451-.005a.87.87 0 0 0-.628.294c-.216.236-.824.805-.824 1.963 0 1.159.844 2.278.961 2.435.118.157 1.629 2.61 4.022 3.553 1.988.784 2.393.629 2.825.59.431-.04 1.393-.57 1.589-1.12s.196-1.02.137-1.119-.216-.157-.451-.275-1.393-.687-1.609-.765c-.216-.079-.372-.118-.53.118-.157.235-.608.765-.745.922-.138.158-.275.177-.51.06-.235-.119-.994-.367-1.893-1.169-.7-.623-1.172-1.394-1.31-1.63-.137-.235-.015-.363.103-.48.106-.106.235-.275.354-.413.117-.137.157-.235.235-.392s.04-.295-.02-.413c-.058-.118-.516-1.282-.725-1.747"
			fill="#fff"
		/>
	</svg>
)

const Tiktok = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={19.995} cy={19.995} r={16.665} fill="#484848" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.805 17.499a7.07 7.07 0 0 0 4.124 1.318V15.86q-.437 0-.866-.09v2.328a7.08 7.08 0 0 1-4.123-1.319v6.036a5.468 5.468 0 0 1-8.515 4.542 5.468 5.468 0 0 0 9.38-3.822zm1.069-2.984a4.13 4.13 0 0 1-1.069-2.414v-.38h-.82a4.14 4.14 0 0 0 1.889 2.794m-8.538 10.524a2.501 2.501 0 0 1 2.75-3.898v-3.023a5.6 5.6 0 0 0-.865-.05v2.353a2.501 2.501 0 0 0-1.885 4.618"
			fill="#EC407A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22.94 16.778a7.07 7.07 0 0 0 4.123 1.319v-2.328a4.14 4.14 0 0 1-2.19-1.255 4.14 4.14 0 0 1-1.888-2.793H20.83v11.812a2.502 2.502 0 0 1-4.494 1.505 2.5 2.5 0 0 1 1.126-4.734c.264 0 .52.041.76.117V18.07a5.467 5.467 0 0 0-3.796 9.287 5.468 5.468 0 0 0 8.515-4.542z"
			fill="#fff"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.063 15.77v-.63a4.1 4.1 0 0 1-2.19-.626 4.13 4.13 0 0 0 2.19 1.255m-4.078-4.05a4 4 0 0 1-.046-.34V11h-2.976v11.813a2.5 2.5 0 0 1-3.628 2.225 2.502 2.502 0 0 0 4.494-1.505V11.721zM18.22 18.07v-.67q-.374-.052-.751-.052a5.468 5.468 0 0 0-3.045 10.01 5.468 5.468 0 0 1 3.796-9.288"
			fill="#81D4FA"
		/>
	</svg>
)

const Snapchat = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.6664 19.9843C36.6755 29.1885 29.2197 36.6577 20.0155 36.6668C10.8113 36.676 3.34218 29.2202 3.33302 20.016C3.32385 10.8118 10.7797 3.34267 19.9839 3.3335C29.188 3.32434 36.6572 10.7802 36.6664 19.9843Z"
			fill="#FEDA01"
		/>
		<path
			d="M19.4941 29.0059C20.1087 29.0059 21.1842 28.783 21.968 28.4002C23.2077 27.7946 24.4524 27.7946 25.0719 27.7946C25.6915 27.7946 25.6915 26.5826 25.6915 26.5826C26.6763 26.4067 27.218 26.1271 27.7568 25.6862C28.1327 25.3782 28.0449 24.9352 27.6145 24.7061C25.5591 23.6104 24.4468 20.6963 24.4468 20.6963L26.8286 19.24C27.2208 18.9527 27.3801 18.4523 27.2258 17.9975C27.0268 17.414 26.3811 17.0991 25.7849 17.2943L24.4489 17.8279V15.9161C24.4489 13.2416 22.2314 11.0059 19.4956 11.0059H19.4927C16.7569 11.0059 14.5394 13.2416 14.5394 15.9161V17.8286L13.2034 17.295C12.6065 17.0998 11.9615 17.4147 11.7625 17.9982C11.6075 18.4523 11.7675 18.9527 12.1597 19.2407L14.5415 20.697C14.5415 20.697 13.4299 23.6104 11.3738 24.7068C10.9433 24.9359 10.8556 25.3796 11.2315 25.6869C11.7696 26.1278 12.312 26.4074 13.2968 26.5832C13.2968 26.5832 13.2968 27.7952 13.9163 27.7952C14.5359 27.7952 15.7806 27.7952 17.0203 28.4009C17.8041 28.783 18.8796 29.0059 19.4941 29.0059Z"
			fill="white"
		/>
	</svg>
)

const Youtube = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#FF3D00"
		/>
		<path
			d="M29.6 24.95a2.5 2.5 0 0 1-2.1 2c-1.65.25-4.4.55-7.5.55-3.05 0-5.8-.3-7.5-.55-1.05-.15-1.9-.95-2.1-2-.2-1.15-.4-2.85-.4-4.95s.2-3.8.4-4.95c.2-1.05 1.05-1.85 2.1-2 1.65-.25 4.4-.55 7.5-.55s5.8.3 7.5.55c1.05.15 1.9.95 2.1 2 .2 1.15.45 2.85.45 4.95-.05 2.1-.25 3.8-.45 4.95"
			fill="#fff"
		/>
		<path d="M18 23.5v-7l6 3.5z" fill="#FF3D00" />
	</svg>
)

const Telegram = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#29B6F6"
		/>
		<path
			d="m27.963 12.75-2.81 14.345s-.12.655-.934.655c-.432 0-.655-.206-.655-.206l-6.085-5.05-2.977-1.5-3.822-1.016s-.68-.197-.68-.76c0-.468.7-.692.7-.692l15.987-6.35c-.001-.001.488-.177.844-.176.22 0 .469.094.469.375 0 .188-.038.375-.038.375"
			fill="#fff"
		/>
		<path
			d="m19.75 24.379-2.57 2.53s-.112.086-.26.09a.4.4 0 0 1-.165-.032l.723-4.474z"
			fill="#B0BEC5"
		/>
		<path
			d="M24.923 15.147a.375.375 0 0 0-.526-.07L14.5 21s1.58 4.42 1.82 5.184c.242.766.435.784.435.784l.723-4.474 7.374-6.822a.374.374 0 0 0 .07-.525"
			fill="#CFD8DC"
		/>
	</svg>
)

const Messenger = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#448AFF"
		/>
		<path
			d="M19.85 11c-4.725 0-8.55 3.645-8.55 8.1 0 2.34 1.035 4.41 2.7 5.895V29l3.51-2.115c.72.18 1.53.315 2.34.315 4.725 0 8.55-3.645 8.55-8.1S24.575 11 19.85 11"
			fill="#fff"
		/>
		<path
			d="m14.45 21.8 4.5-4.95 2.25 2.25 4.05-2.25-4.5 4.95-2.25-2.25z"
			fill="#448AFF"
		/>
	</svg>
)

const Yelp = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#DD2C00"
		/>
		<path
			d="M14.458 23.625c-.208 0-.375-.125-.5-.333-.083-.167-.125-.417-.167-.709-.083-.916 0-2.291.292-2.708a.59.59 0 0 1 .5-.292c.125 0 .25.042 2.958 1.167l.792.333c.292.125.458.417.458.75a.676.676 0 0 1-.5.667l-1.125.375c-2.5.75-2.583.75-2.708.75m5.542 1.5c0 2.625 0 2.708-.042 2.833a.6.6 0 0 1-.458.375c-.667.125-2.75-.666-3.209-1.166a1.3 1.3 0 0 1-.166-.334c0-.083 0-.166.041-.25.042-.125.125-.25 2-2.458l.542-.667c.167-.25.542-.291.833-.208.292.125.5.375.459.667zm-.5-5.583c-.125.041-.542.166-1.042-.667 0 0-3.375-5.375-3.458-5.542a.65.65 0 0 1 .166-.583c.5-.542 3.209-1.292 3.917-1.125.25.042.375.208.458.417.042.25.375 5.208.417 6.333.083 1-.333 1.125-.458 1.167m1.833 1.25c-.167-.25-.167-.584 0-.792l.708-.958c1.5-2.084 1.584-2.209 1.709-2.25.166-.125.375-.125.583-.042.583.292 1.833 2.125 1.917 2.792v.041c0 .25-.084.417-.25.542-.125.083-.209.125-3.084.792-.458.125-.708.166-.833.208v-.042c-.25.125-.583-.041-.75-.291m4.875 3.541C26.125 25 24.75 26.75 24.083 27c-.208.083-.417.083-.583-.083-.125-.084-.209-.25-1.709-2.667l-.458-.708c-.167-.25-.125-.584.083-.875.209-.25.5-.334.792-.25l1.125.375c2.5.833 2.583.833 2.667.916.166.209.25.417.208.625"
			fill="#fff"
		/>
	</svg>
)

const GoogleReviews = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M19.997 3.33a16.667 16.667 0 1 0 0 33.333 16.667 16.667 0 0 0 0-33.333"
			fill="#F4511E"
		/>
		<path
			d="m28.815 18.2-.05-.2H20v3h5.91A5.996 5.996 0 0 1 14 20a6 6 0 0 1 6-6c1.5 0 2.868.554 3.92 1.465l2.151-2.106A9 9 0 0 0 11 20a9 9 0 0 0 9 9 9 9 0 0 0 9-9c0-.617-.066-1.218-.185-1.8"
			fill="#fff"
		/>
	</svg>
)

const Pinterest = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.204-7.446 16.673-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.342 19.983 3.333c9.205-.009 16.674 7.447 16.683 16.651"
			fill="url(#pinterest-gradient)"
		/>
		<path
			d="M20.369 9.514c-7.193 0-11.013 4.83-11.013 10.086 0 2.444 1.302 5.487 3.384 6.457.315.147.485.083.556-.223.056-.232.336-1.364.463-1.89a.5.5 0 0 0-.115-.477c-.69-.836-1.24-2.373-1.24-3.804 0-3.677 2.783-7.234 7.525-7.234 4.094 0 6.96 2.79 6.96 6.781 0 4.508-2.276 7.632-5.238 7.632-1.636 0-2.861-1.353-2.469-3.013.471-1.98 1.381-4.118 1.381-5.548 0-1.28-.686-2.348-2.108-2.348-1.673 0-3.015 1.73-3.015 4.048 0 1.475.498 2.473.498 2.473s-1.652 6.985-1.954 8.285c-.335 1.435-.205 3.451-.06 4.77.377.147.752.294 1.142.415.68-1.106 1.695-2.922 2.071-4.368.203-.781 1.04-3.963 1.04-3.963.543 1.036 2.13 1.915 3.819 1.915 5.026 0 8.648-4.623 8.648-10.367 0-5.508-4.493-9.627-10.275-9.627"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="pinterest-gradient"
				x1={12.505}
				y1={5.418}
				x2={27.991}
				y2={35.547}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#F22543" />
				<stop offset={0.422} stopColor="#EB2239" />
				<stop offset={1} stopColor="#E52030" />
			</linearGradient>
		</defs>
	</svg>
)

const Linkedin = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#0288D1"
		/>
		<path
			d="M11.667 15.833H15v12.5h-3.333zm1.657-1.666h-.019c-.995 0-1.638-.742-1.638-1.668 0-.946.663-1.666 1.676-1.666 1.014 0 1.638.72 1.657 1.666 0 .926-.643 1.668-1.676 1.668m15.843 6.25a4.583 4.583 0 0 0-8.333-2.63v-1.954H17.5v12.5h3.334v-6.666a2.5 2.5 0 1 1 5 0v6.666h3.333z"
			fill="#fff"
		/>
	</svg>
)

const Xing = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#006064"
		/>
		<path
			d="M15.257 23.214H12.66a.38.38 0 0 1-.338-.175.4.4 0 0 1 0-.396l2.758-4.836c.003-.007.003-.009 0-.015l-1.755-3.019c-.074-.143-.084-.284-.015-.395.065-.108.196-.164.353-.164h2.596c.398 0 .593.256.722.486l1.785 3.092-2.802 4.923c-.132.239-.32.5-.708.5"
			fill="#fff"
		/>
		<path
			d="M27.642 11.566 21.895 21.73q-.005.01 0 .016l3.66 6.689c.071.144.075.289.005.4-.067.107-.187.166-.344.166h-2.593c-.397 0-.597-.264-.725-.496l-3.689-6.766 5.775-10.243c.14-.25.309-.495.695-.495h2.625c.155 0 .279.059.344.166.068.111.066.256-.006.4"
			fill="#CDDC39"
		/>
	</svg>
)

const Dribbble = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 36.146c8.917 0 16.146-7.229 16.146-16.146S28.917 3.854 20 3.854 3.854 11.083 3.854 20 11.084 36.146 20 36.146"
			fill="#ED3675"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 9.5C14.204 9.5 9.5 14.204 9.5 20S14.204 30.5 20 30.5c5.785 0 10.5-4.703 10.5-10.5S25.785 9.5 20 9.5m6.935 4.84a8.93 8.93 0 0 1 2.027 5.58c-.296-.057-3.257-.66-6.24-.284-.069-.148-.126-.308-.194-.467a27 27 0 0 0-.592-1.298c3.302-1.344 4.806-3.28 5-3.531M20 11.049a8.95 8.95 0 0 1 5.945 2.255c-.16.227-1.515 2.038-4.704 3.234-1.469-2.7-3.097-4.909-3.348-5.25a9.2 9.2 0 0 1 2.107-.24m-3.815.842c.239.32 1.833 2.54 3.325 5.182-4.19 1.116-7.892 1.094-8.29 1.094a9.01 9.01 0 0 1 4.965-6.276m-5.159 8.12v-.273c.388.012 4.738.068 9.213-1.276.262.501.501 1.014.73 1.526-.115.035-.24.069-.354.103-4.623 1.492-7.083 5.569-7.288 5.91a8.95 8.95 0 0 1-2.3-5.99M20 28.975a8.9 8.9 0 0 1-5.5-1.89c.16-.33 1.98-3.838 7.038-5.603.022-.012.034-.012.057-.023 1.264 3.269 1.777 6.013 1.913 6.799a8.8 8.8 0 0 1-3.508.717m5-1.537c-.092-.547-.57-3.166-1.743-6.39 2.813-.443 5.273.285 5.58.388A8.9 8.9 0 0 1 25 27.437"
			fill="#fff"
		/>
	</svg>
)

const TripAdvisor = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.204-7.446 16.673-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.342 19.983 3.333c9.205-.009 16.674 7.447 16.683 16.651"
			fill="#479951"
		/>
		<path
			d="M20 14c-2.659 0-5.14.713-6.836 1.855H10c.518.606.9 1.431.996 1.993a4.97 4.97 0 0 0-.957 2.93 4.983 4.983 0 0 0 4.98 4.98c1.56 0 2.955-.733 3.868-1.856.37.435.988 1.309 1.113 1.563 0 0 .71-1.05 1.113-1.543a4.982 4.982 0 0 0 8.848-3.145 4.98 4.98 0 0 0-.957-2.93c.095-.56.478-1.386.996-1.992h-3.32C24.983 14.714 22.656 14 20 14m0 .84c1.782 0 3.398.334 4.824.957A4.985 4.985 0 0 0 20 20.777a4.97 4.97 0 0 0-4.96-4.98c1.422-.62 3.18-.957 4.96-.957m-4.98 1.914c2.214 0 4.003 1.811 4.003 4.023a4 4 0 0 1-4.003 4.004 4 4 0 0 1-4.004-4.004c0-2.212 1.79-4.023 4.004-4.023m9.96 0c2.212 0 4.004 1.811 4.004 4.023a4 4 0 0 1-4.004 4.004 4 4 0 0 1-4.003-4.004c0-2.212 1.79-4.023 4.003-4.023m-10.02 1.582a2.425 2.425 0 0 0-2.42 2.422 2.425 2.425 0 0 0 2.42 2.422 2.425 2.425 0 0 0 2.423-2.422 2.425 2.425 0 0 0-2.422-2.422m10.02 0a2.425 2.425 0 0 0-2.421 2.422 2.41 2.41 0 0 0 2.421 2.402 2.41 2.41 0 0 0 2.422-2.402 2.425 2.425 0 0 0-2.422-2.422m-10.02.742c.926 0 1.68.755 1.68 1.68s-.754 1.68-1.68 1.68c-.924 0-1.679-.755-1.679-1.68s.755-1.68 1.68-1.68m10.02 0c.926 0 1.68.755 1.68 1.68s-.754 1.66-1.68 1.66-1.68-.735-1.68-1.66.755-1.68 1.68-1.68m-10.136.86c-.45 0-.82.37-.82.82s.37.82.82.82.8-.371.8-.82c0-.45-.351-.82-.8-.82m10 0c-.45 0-.801.37-.801.82s.352.8.8.8c.45 0 .821-.351.821-.8s-.371-.82-.82-.82"
			fill="#fff"
		/>
	</svg>
)

const Line = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx={19.995} cy={19.995} r={16.665} fill="#00C300" />
		<path
			d="M29.5 19.665C29.5 15.44 25.238 12 20 12s-9.5 3.439-9.5 7.665c0 3.79 3.38 6.963 7.945 7.563.31.066.73.203.837.466.096.238.062.612.03.854 0 0-.11.666-.135.808-.041.239-.19.934.823.51 1.014-.425 5.47-3.203 7.463-5.485 1.377-1.5 2.037-3.024 2.037-4.716M16.282 22.18h-1.888a.497.497 0 0 1-.498-.496v-3.753a.497.497 0 0 1 .996 0v3.258h1.39a.497.497 0 1 1 0 .991m1.951-.496a.498.498 0 0 1-.995 0v-3.753a.497.497 0 0 1 .995 0zm4.545 0a.493.493 0 0 1-.499.496.5.5 0 0 1-.398-.198l-1.934-2.62v2.322a.498.498 0 0 1-.998 0v-3.753a.495.495 0 0 1 .5-.495c.154 0 .303.074.397.198l1.935 2.62V17.93a.498.498 0 0 1 .997 0zm3.054-2.372c.275 0 .499.222.499.496a.497.497 0 0 1-.5.495h-1.389v.886h1.39c.275 0 .499.222.499.495a.5.5 0 0 1-.5.496h-1.886a.497.497 0 0 1-.498-.496v-3.753c0-.273.223-.495.498-.495h1.887c.275 0 .499.222.499.495a.497.497 0 0 1-.5.495h-1.389v.887z"
			fill="#fff"
		/>
	</svg>
)

const Reddit = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.204-7.446 16.673-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.342 19.983 3.333c9.205-.009 16.674 7.447 16.683 16.651"
			fill="#FF4500"
		/>
		<path
			d="M21.597 12.2a2.196 2.196 0 0 0-2.197 2.197v2.024c-1.65.088-3.16.528-4.364 1.218-.464-.446-1.086-.644-1.689-.644-.653 0-1.321.227-1.782.746l-.01.011-.011.012c-.442.553-.617 1.293-.5 2.027a2.64 2.64 0 0 0 1.172 1.786c-.004.075-.016.148-.016.223 0 2.977 3.5 5.4 7.8 5.4s7.8-2.423 7.8-5.4c0-.075-.012-.148-.016-.223a2.64 2.64 0 0 0 1.172-1.786c.117-.734-.058-1.474-.5-2.027l-.01-.012-.01-.011c-.462-.519-1.13-.745-1.783-.746-.603 0-1.225.198-1.689.644-1.205-.69-2.714-1.13-4.364-1.218v-2.024c0-.587.34-.997.997-.997.313 0 .693.156 1.29.366a7.4 7.4 0 0 0 1.997.409A1.5 1.5 0 0 0 26.3 15.2c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5a1.5 1.5 0 0 0-1.308.78 5.9 5.9 0 0 1-1.708-.347c-.543-.19-1.04-.433-1.687-.433m-8.25 5.995c.237 0 .463.062.648.163-.662.553-1.165 1.199-1.468 1.904a1.4 1.4 0 0 1-.296-.66c-.065-.404.056-.822.247-1.07.18-.195.51-.337.87-.337m13.305 0c.358 0 .69.142.87.337.192.248.312.666.248 1.07a1.4 1.4 0 0 1-.297.66c-.303-.705-.806-1.35-1.468-1.904.185-.1.41-.163.647-.163M17 19.4a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4m6 0a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4m.143 3.32c-.383 1.12-1.61 2.08-3.143 2.08s-2.76-.96-3.143-2c.69.56 1.84.96 3.143.96s2.453-.4 3.143-1.04"
			fill="#fff"
		/>
	</svg>
)

const Viber = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#7E57C2"
		/>
		<path
			d="M19.88 10q-.887.003-1.786.112c-1.146.14-2.282.375-3.373.876-1.734.796-2.963 2.148-3.32 4.113-.151.829-.273 1.67-.343 2.515-.134 1.643-.051 3.29.414 4.909.367 1.275 1.043 2.422 2.227 3.165.5.314 1.162.467 1.506.627.097.046.12.073.126.08.005.005.019.017.017.119-.012 1.04 0 3.05 0 3.05l.002.433h.776l.125-.122s1.972-1.897 2.685-2.678c.13-.14.196-.218.21-.226.011-.009-.01-.014.123-.017q1.404-.03 2.804-.106c1.232-.068 2.487-.185 3.694-.69 1.052-.44 1.93-1.157 2.461-2.234.544-1.104.834-2.274.943-3.485.18-2.016.117-4.035-.44-6.026-.328-1.167-.987-2.153-1.997-2.85-1.21-.832-2.573-1.144-3.908-1.343a20 20 0 0 0-2.352-.216A17 17 0 0 0 19.88 10m.57.876c.749.02 1.498.093 2.248.205 1.288.192 2.502.484 3.543 1.201.844.58 1.37 1.366 1.652 2.366.52 1.861.586 3.768.412 5.716-.1 1.123-.367 2.181-.858 3.178-.433.88-1.11 1.438-2.016 1.817-1.053.44-2.198.557-3.404.624q-1.385.075-2.775.103c-.232.005-.46.066-.621.185-.162.12-.235.23-.335.338-.51.557-1.525 1.537-2.078 2.074-.004-.649-.009-1.434 0-2.157a1.06 1.06 0 0 0-.175-.63 1.14 1.14 0 0 0-.47-.367c-.492-.228-1.134-.4-1.412-.576-.973-.611-1.525-1.528-1.853-2.67-.43-1.492-.511-3.03-.384-4.594a25 25 0 0 1 .333-2.431c.31-1.7 1.28-2.77 2.826-3.48.976-.449 2.02-.67 3.118-.804.75-.091 1.498-.12 2.249-.098m.183 2.167q-.537.001-1.044.115a.436.436 0 0 0 .194.85 3.828 3.828 0 0 1 4.686 3.738q-.002.44-.096.854a.435.435 0 1 0 .847.19q.116-.504.117-1.044a4.71 4.71 0 0 0-4.704-4.703m-4.337.871a.8.8 0 0 0-.221.019c-.79.175-1.574.747-1.597 1.77.023.142.02.295.073.424.259.632.483 1.284.805 1.882 1.571 2.904 3.947 4.923 6.975 6.206.362.152.736.185 1.101.032.503-.21.929-.532 1.213-.995.389-.637.394-1.079-.247-1.55-.42-.308-.832-.626-1.256-.928-.648-.459-1.347-.539-1.83.266-.025.041-.062.075-.095.109-.248.263-.552.328-.874.195-1.225-.504-2.17-1.318-2.741-2.529-.337-.711-.245-1.068.383-1.542q.095-.068.18-.147c.276-.252.349-.55.186-.889a7 7 0 0 0-1.481-2.051.9.9 0 0 0-.574-.272m4.33.433q-.288 0-.569.048a.436.436 0 0 0-.276.713c.103.12.266.177.422.143q.206-.034.423-.034a2.54 2.54 0 0 1 2.548 2.547q0 .218-.034.423a.44.44 0 0 0 .142.423.436.436 0 0 0 .713-.277q.049-.28.048-.569a3.424 3.424 0 0 0-3.417-3.417m-.06 1.305a.44.44 0 0 0-.383.215.44.44 0 0 0 0 .438c.08.136.226.218.382.216.725 0 1.304.58 1.304 1.304a.44.44 0 0 0 .216.383.44.44 0 0 0 .438 0 .44.44 0 0 0 .216-.383 2.18 2.18 0 0 0-2.174-2.173"
			fill="#fff"
		/>
	</svg>
)

const Tumblr = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.204-7.446 16.673-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.342 19.983 3.333c9.205-.009 16.674 7.447 16.683 16.651"
			fill="#3B445C"
		/>
		<path
			d="M20.4 12.8v3.6h3.2v2h-3.2v4.954c-.001.197.033.876.517 1.363.32.32.753.483 1.289.483.782 0 1.633-.258 2.194-.467v1.537c-.453.28-1.733.93-3.844.93-1.231 0-2.095-.565-2.568-1.68-.25-.59-.388-1.333-.388-2.095V18.4h-2v-1.347c2.427-1.183 3.085-2.924 3.185-4.251zm.202-.4c-.454 0-1.562 0-2.01.002a.2.2 0 0 0-.195.195c-.106 2.737-2.416 3.836-3.084 4.15a.2.2 0 0 0-.113.18V18.6c0 .11.09.2.2.2h1.8v4.625c0 .427-.003 4.175 3.356 4.175 2.406 0 3.81-.824 4.158-1.056a.2.2 0 0 0 .086-.165v-1.94a.2.2 0 0 0-.275-.184c-.468.19-1.452.545-2.32.545-1.433 0-1.405-1.389-1.405-1.447V18.8h3a.2.2 0 0 0 .2-.2v-2.4a.2.2 0 0 0-.2-.2h-3v-3.4c0-.11-.088-.2-.198-.2Z"
			fill="#fff"
			stroke="#fff"
			strokeWidth={0.75}
		/>
	</svg>
)

const Github = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M34.166 20c0 7.833-6.333 14.167-14.166 14.167S5.833 27.833 5.833 20 12.166 5.833 20 5.833 34.166 12.167 34.166 20"
			fill="#fff"
		/>
		<path
			d="M17.5 34.167v-4.584c0-.25.167-.416.417-.416s.417.166.417.416v4.584H20V28.75c0-.25.167-.417.417-.417s.417.167.417.417v5.417H22.5v-4.584c0-.25.167-.416.417-.416s.417.166.417.416v4.584h1.5c.166-.25.166-.5.166-.917V30c0-1.833-1.583-4.333-3.583-4.333h-2.083c-1.917 0-3.584 2.583-3.584 4.333v3.25c0 .333.084.667.167.917zM33.417 22s-1.083-.333-2-.333h-.083c-.917 0-2.417.25-2.417.25-.083 0-.083 0-.083-.084 0-.083 0-.083.083-.083s1.667-.25 2.583-.25 2 .333 2.084.333c.083 0 .083.084.083.167-.167-.083-.167 0-.25 0m-.25.667S32 22.333 31 22.333c-.75 0-2.5.167-2.583.167s-.083 0-.083-.083c0-.084 0-.084.083-.084s1.833-.166 2.583-.166c1.084 0 2.167.333 2.167.333.083 0 .083.083.083.167 0-.084 0 0-.083 0M6.5 22c-.083 0-.083 0-.083-.083 0-.084 0-.084.083-.167.667-.167 2-.417 2.75-.417.667 0 2.917.167 3 .167s.084.083.084.083c0 .084-.084.084-.084.084S10 21.5 9.334 21.5c-.917.167-2.167.333-2.834.5m.334 1.25s-.084 0-.084-.083V23c.084 0 1.167-.667 2.417-.833 1.083-.167 3.333.083 3.5.083.083 0 .083.083.083.083 0 .084-.083.084-.083.084s-2.333-.25-3.417-.084c-1.25.25-2.416.917-2.416.917"
			fill="#455A64"
		/>
		<path
			d="M11.833 19.583c0-3.666 3.833-7.083 8.583-7.083S29 15.833 29 19.583s-2.75 6.25-8.584 6.25-8.583-2.583-8.583-6.25"
			fill="#455A64"
		/>
		<path
			d="M23.833 13.583s1.417-1.916 4-1.916c1 1 .333 4 0 4.833zm-6.833 0s-1.417-1.916-4-1.916c-1 1-.334 4 0 4.833zm-.25 16.334h-2.334c-1 0-1.916-.417-2.333-1.25-.5-.917-.917-1.917-2.167-2.75-.25-.167-.083-.334.334-.334.416.084 1.166.167 1.75.917.583.75 1.25 1.667 2.333 1.667s2.25 0 2.917-.75z"
			fill="#455A64"
		/>
		<path
			d="M20 3.333c-9.167 0-16.667 7.5-16.667 16.667S10.833 36.667 20 36.667c9.166 0 16.666-7.5 16.666-16.667S29.166 3.333 20 3.333m0 30c-7.334 0-13.334-6-13.334-13.333S12.666 6.667 20 6.667s13.333 6 13.333 13.333-6 13.333-13.333 13.333"
			fill="#00BCD4"
		/>
	</svg>
)

const Doordash = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.666 19.984c.01 9.204-7.446 16.673-16.65 16.683-9.205.009-16.674-7.447-16.683-16.651S10.78 3.342 19.983 3.333c9.205-.009 16.674 7.447 16.683 16.651"
			fill="#FF3008"
		/>
		<path
			d="M24.468 15H10.426a.426.426 0 0 0-.311.717l2.687 2.866c.401.427.967.672 1.553.672h9.262c.704 0 1.277.573 1.277 1.277s-.573 1.276-1.277 1.276h-6.383a.426.426 0 0 0-.31.717l2.686 2.867c.401.427.967.672 1.553.672h3.305A5.54 5.54 0 0 0 30 20.532 5.54 5.54 0 0 0 24.468 15"
			fill="#fff"
		/>
	</svg>
)

const Vk = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="#1976D2"
		/>
		<path
			d="M29.948 15.034q.058-.19.051-.346c-.012-.302-.22-.521-.708-.521h-2.182c-.55 0-.805.333-.953.667 0 0-1.36 2.8-2.928 4.645-.508.534-.766.521-1.041.521-.148 0-.52-.178-.52-.667v-4.321c0-.579-.145-.845-.61-.845h-3.874c-.34 0-.516.266-.516.534 0 .556.748.69.833 2.247v3.019c0 .733-.128.866-.402.866-.742 0-2.202-2.5-3.18-5.776-.211-.645-.423-.89-.974-.89h-2.202c-.636 0-.742.311-.742.645 0 .6.5 3.849 3.23 7.584 1.978 2.708 4.586 4.27 6.894 4.27 1.399 0 1.542-.355 1.542-.91v-2.478c0-.667.153-.778.598-.778.318 0 .965.208 2.215 1.667 1.442 1.681 1.704 2.5 2.53 2.5h2.182c.507 0 .797-.213.809-.625a1.3 1.3 0 0 0-.047-.354c-.161-.48-.903-1.653-1.828-2.771-.512-.62-1.018-1.233-1.25-1.566-.157-.218-.216-.37-.208-.518.007-.154.087-.3.207-.505-.021 0 2.799-3.96 3.074-5.294"
			fill="#fff"
		/>
	</svg>
)

const Signal = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M20 3.333a16.667 16.667 0 1 0 0 33.334 16.667 16.667 0 0 0 0-33.334"
			fill="url(#signal-gradient)"
		/>
		<path
			d="M11.655 28.691a.35.35 0 0 1-.344-.389l.173-1.373.687.086-.117.931.931-.117.087.687-1.374.173zM20 29c-.553 0-1.11-.052-1.653-.155l.129-.68a8.4 8.4 0 0 0 2.628.07l.091.686A9 9 0 0 1 20 29m2.592-.38-.2-.664a8.2 8.2 0 0 0 2.365-1.149l.397.567a9 9 0 0 1-2.562 1.245m-5.623-.15a9 9 0 0 1-.82-.342l-1.68.212-.087-.687 1.781-.225a.36.36 0 0 1 .196.033q.411.202.844.358zm9.287-2.005-.48-.497a8.3 8.3 0 0 0 1.578-2.104l.612.324a9 9 0 0 1-1.71 2.277m-13.912-.815-.687-.087.216-1.711a9 9 0 0 1-.33-.79l.65-.237q.151.419.347.816c.03.06.041.128.032.196zm16.186-2.776-.656-.221a8.3 8.3 0 0 0 .434-2.593l.693.005a9 9 0 0 1-.471 2.81m-17.37-1.188a9 9 0 0 1-.085-2.849l.687.09a8.3 8.3 0 0 0 .079 2.628zm17.054-2.942a8.2 8.2 0 0 0-.804-2.501l.617-.314a9 9 0 0 1 .872 2.712zm-16.18-1.107-.664-.198a9 9 0 0 1 1.236-2.567l.569.396a8.3 8.3 0 0 0-1.14 2.369m14.686-2.518a8.4 8.4 0 0 0-1.864-1.857l.406-.56a9 9 0 0 1 2.017 2.009zm-12.708-.872-.5-.479a9 9 0 0 1 2.27-1.718l.327.61a8.3 8.3 0 0 0-2.097 1.587m9.717-1.671a8.2 8.2 0 0 0-2.506-.795l.101-.685c.947.14 1.861.43 2.715.862zm-6.411-.44-.226-.655A9 9 0 0 1 19.9 11l.008.692c-.887.01-1.758.16-2.59.445"
			fill="#fff"
		/>
		<path
			opacity={0.05}
			d="M20 13.077a6.923 6.923 0 1 1 0 13.846 6.9 6.9 0 0 1-3.59-1.011l-2.704.382.383-2.704A6.9 6.9 0 0 1 13.077 20c0-3.824 3.1-6.923 6.923-6.923m0-.693c-4.199 0-7.615 3.417-7.615 7.616 0 1.304.34 2.589.984 3.732l-.348 2.465-.129.911.911-.129 2.466-.348a7.6 7.6 0 0 0 3.731.985c4.2 0 7.616-3.417 7.616-7.616 0-4.2-3.416-7.616-7.616-7.616"
			fill="#000"
		/>
		<path
			opacity={0.07}
			d="M20 13.077a6.923 6.923 0 1 1 0 13.846 6.9 6.9 0 0 1-3.59-1.011l-2.704.382.382-2.704A6.9 6.9 0 0 1 13.077 20c0-3.824 3.1-6.923 6.923-6.923m0-.347c-4.009 0-7.27 3.261-7.27 7.27a7.25 7.25 0 0 0 .998 3.662l-.365 2.584-.064.455.455-.064 2.584-.365A7.25 7.25 0 0 0 20 27.27c4.009 0 7.27-3.261 7.27-7.27s-3.261-7.27-7.27-7.27"
			fill="#000"
		/>
		<path
			d="M20 13.077A6.923 6.923 0 0 0 13.077 20a6.9 6.9 0 0 0 1.012 3.59l-.383 2.704 2.705-.382A6.9 6.9 0 0 0 20 26.923a6.923 6.923 0 1 0 0-13.846"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="signal-gradient"
				x1={20}
				y1={3.758}
				x2={20}
				y2={41.288}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#2AA4F4" />
				<stop offset={1} stopColor="#007AD9" />
			</linearGradient>
		</defs>
	</svg>
)

const Outlook = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.66 19.995c0-9.204-7.461-16.665-16.665-16.665S3.33 10.791 3.33 19.995 10.791 36.66 19.995 36.66 36.66 29.2 36.66 19.995"
			fill="#0072C6"
		/>
		<path
			d="m21.865 9.33-12.42 2.403v16.324l12.42 2.604zm.784 4.522v4.171l1.458.92a.4.4 0 0 0 .16 0l6.276-4.232c0-.5-.466-.86-.73-.86zm-6.853 2.412q1.23 0 1.987 1.005.76 1.007.76 2.656 0 1.694-.786 2.73-.788 1.035-2.054 1.036-1.234 0-2.01-1.003-.779-1.005-.78-2.618.001-1.703.791-2.754t2.092-1.052m14.749.133s-6.375 4.238-6.15 4.1c0 0-.227.137-.414 0l-1.332-.914v5.67h6.76c.6 0 1.136-.352 1.136-1.186zm-14.786 1.261q-.681 0-1.08.639-.403.637-.403 1.69 0 1.066.402 1.687.4.62 1.05.619.669 0 1.06-.604.393-.603.393-1.675 0-1.116-.38-1.736-.382-.62-1.042-.62"
			fill="#fff"
		/>
	</svg>
)

const Apple = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.66 19.995c0-9.204-7.461-16.665-16.665-16.665S3.33 10.791 3.33 19.995 10.791 36.66 19.995 36.66 36.66 29.2 36.66 19.995"
			fill="#000"
		/>
		<path
			d="M20.024 13.781c.433 0 1.837-.275 2.926-1.864.931-1.379.827-2.915.827-2.915s-1.614-.119-3.031 1.641c-1.023 1.287-.945 3.125-.945 3.125s.079.013.223.013"
			fill="#fff"
		/>
		<path
			d="M28.119 23.879c.079-.223.131-.355.131-.355h-.013s-.013 0-.026-.013a2.7 2.7 0 0 1-.499-.25 4.44 4.44 0 0 1-1.6-1.614c-.302-.525-.512-1.182-.565-1.996a4.1 4.1 0 0 1 .092-1.156v-.013c.026-.118.053-.223.092-.341.42-1.366 1.404-2.259 1.797-2.56l.158-.119s-1.26-1.956-3.634-1.956c-2.047 0-2.808.919-3.897.919-1.338 0-1.548-.854-3.53-.854-1.023 0-2.453.394-3.515 1.773-.84 1.077-1.155 2.35-1.286 3.283a9 9 0 0 0-.027 2.074c0 .053.014.105.014.171.078.762.275 1.576.55 2.39a.1.1 0 0 0 .027.052c.026.092.066.197.105.29.013.039.04.091.052.13.014.04.027.092.053.132.262.683.564 1.34.918 1.956C14.54 27.634 15.865 29 17.111 29c1.417 0 1.863-.92 3.28-.906 1.798.013 2.296 1.156 3.805.854 1.01-.197 2.217-1.629 2.991-2.994.026-.053.053-.092.079-.132.367-.787.682-1.523.853-1.943"
			fill="#fff"
		/>
	</svg>
)

const Gmail = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M19.995 3.83c8.928 0 16.165 7.237 16.165 16.165S28.923 36.16 19.995 36.16 3.83 28.923 3.83 19.995 11.067 3.83 19.995 3.83Z"
			fill="#fff"
			stroke="#D9DCE1"
		/>
		<path
			d="M11.364 27h3.182v-7.727L10 15.863v9.774c0 .754.611 1.363 1.364 1.363"
			fill="#4285F4"
		/>
		<path
			d="M25.455 27h3.182C29.39 27 30 26.39 30 25.637v-9.773l-4.545 3.409"
			fill="#34A853"
		/>
		<path
			d="M25.455 13.364v5.909l4.546-3.41v-1.818c0-1.686-1.925-2.647-3.273-1.636"
			fill="#FBBC04"
		/>
		<path
			d="M14.545 19.273v-5.91L20 17.456l5.454-4.091v5.909L20 23.363"
			fill="#EA4335"
		/>
		<path
			d="M10 14.045v1.819l4.546 3.409v-5.91l-1.273-.954C11.923 11.398 10 12.36 10 14.045"
			fill="#C5221F"
		/>
	</svg>
)

const Netflix = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M36.66 19.995c0-9.204-7.461-16.665-16.665-16.665S3.33 10.791 3.33 19.995 10.791 36.66 19.995 36.66 36.66 29.2 36.66 19.995"
			fill="#000"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m21.075 10.502-.008 4.42-.008 4.42-.363-1.026v-.002l-.47 9.84c.462 1.304.709 2 .712 2.003s.266.02.584.036c.962.048 2.155.15 3.06.263.209.026.39.04.4.03s.017-4.51.013-10.001l-.006-9.983zm-7.079-.013v9.993c0 5.496.005 9.998.012 10.005.007.006.346-.026.755-.072s.974-.103 1.256-.126c.432-.037 1.722-.12 1.87-.12.044-.001.047-.226.053-4.234l.007-4.232.312.885.11.312.47-9.837-.162-.457-.722-2.045-.026-.072z"
			fill="#B1060F"
			stroke="#000"
			strokeWidth={0.082}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.996 10.489v5.609l3.945 10.482.002-.645.006-4.232.312.885c1.738 4.924 2.671 7.564 2.677 7.57.003.003.266.019.584.035a45 45 0 0 1 3.06.263c.209.026.389.04.4.03.007-.007.012-2.214.014-5.327l-3.927-11.307-.002 1.07-.008 4.42-.363-1.026-2.74-7.755-.025-.072z"
			fill="url(#a)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m13.996 10.489 3.953 11.22v-.006l.312.885c1.738 4.924 2.67 7.564 2.676 7.57.004.003.267.019.584.035a45 45 0 0 1 3.06.263c.209.026.388.039.4.03L21.06 19.34v.002l-.363-1.026-2.74-7.755-.025-.072h-3.935"
			fill="#E50914"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m21.075 10.502-.008 4.42-.008 4.42-.363-1.026v-.002l-.47 9.84c.462 1.304.709 2 .712 2.003s.266.02.584.036c.962.048 2.155.15 3.06.263.209.026.39.04.4.03s.017-4.51.013-10.001l-.006-9.983zm-7.079-.013v9.993c0 5.496.005 9.998.012 10.005.007.006.346-.026.755-.072s.974-.103 1.256-.126c.432-.037 1.722-.12 1.87-.12.044-.001.047-.226.053-4.234l.007-4.232.312.885.11.312.47-9.837-.162-.457-.722-2.045-.026-.072z"
			fill="#B1060F"
			stroke="#000"
			strokeWidth={0.082}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.996 10.489v5.609l3.945 10.482.002-.645.006-4.232.312.885c1.738 4.924 2.671 7.564 2.677 7.57.003.003.266.019.584.035a45 45 0 0 1 3.06.263c.209.026.389.04.4.03.007-.007.012-2.214.014-5.327l-3.927-11.307-.002 1.07-.008 4.42-.363-1.026-2.74-7.755-.025-.072z"
			fill="url(#b)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m13.996 10.489 3.953 11.22v-.006l.312.885c1.738 4.924 2.67 7.564 2.676 7.57.004.003.267.019.584.035a45 45 0 0 1 3.06.263c.209.026.388.039.4.03L21.06 19.34v.002l-.363-1.026-2.74-7.755-.025-.072h-3.935"
			fill="#E50914"
		/>
		<defs>
			<radialGradient
				id="a"
				cx={0}
				cy={0}
				r={1}
				gradientUnits="userSpaceOnUse"
				gradientTransform="rotate(-19.127 70.114 -47.128)scale(2.49352 91.4532)"
			>
				<stop />
				<stop offset={1} stopOpacity={0} />
			</radialGradient>
			<radialGradient
				id="b"
				cx={0}
				cy={0}
				r={1}
				gradientUnits="userSpaceOnUse"
				gradientTransform="rotate(-19.127 70.114 -47.128)scale(2.49352 91.4532)"
			>
				<stop />
				<stop offset={1} stopOpacity={0} />
			</radialGradient>
		</defs>
	</svg>
)

const X = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#x)">
			<path
				d="M19.665 3C10.462 3 3 10.461 3 19.665S10.461 36.33 19.665 36.33 36.33 28.869 36.33 19.665 28.869 3 19.665 3"
				fill="#000"
			/>
			<path
				d="M21.522 18.198 27.48 11h-1.412l-5.172 6.25-4.13-6.25H12l6.247 9.451L12 28h1.412l5.461-6.6 4.363 6.6H28zm-7.602-6.093h2.168l9.98 14.84H23.9z"
				fill="#fff"
			/>
		</g>
		<defs>
			<clipPath id="x">
				<path fill="#fff" d="M3 3h33.33v33.33H3z" />
			</clipPath>
		</defs>
	</svg>
)

export const SOCIAL_PLATFORM_ICONS = {
	Facebook,
	Instagram,
	Twitter,
	X,
	Whatsapp,
	Tiktok,
	Snapchat,
	Youtube,
	Telegram,
	Messenger,
	Yelp,
	GoogleReviews,
	Pinterest,
	Linkedin,
	Xing,
	Dribbble,
	TripAdvisor,
	Line,
	Reddit,
	Viber,
	Tumblr,
	Github,
	Doordash,
	Vk,
	Signal,
	Outlook,
	Apple,
	Gmail,
	Netflix,
	Web,
} as const

export const SOCIAL_PLATFORM_LIST = [
	{
		id: 'facebook',
		name: 'Facebook',
		Icon: SOCIAL_PLATFORM_ICONS.Facebook,
		src: '/qr-code-generator/social-networks/facebook.svg',
		provider: 'none',
	},
	{
		id: 'instagram',
		name: 'Instagram',
		Icon: SOCIAL_PLATFORM_ICONS.Instagram,
		src: '/qr-code-generator/social-networks/instagram.svg',
		provider: 'none',
	},
	{
		id: 'twitter',
		name: 'Twitter',
		Icon: SOCIAL_PLATFORM_ICONS.Twitter,
		src: '/qr-code-generator/social-networks/twitter.svg',
		provider: 'none',
	},
	{
		id: 'twitter-alt',
		name: 'Twitter',
		Icon: SOCIAL_PLATFORM_ICONS.X,
		src: '/qr-code-generator/social-networks/twitter.svg',
		provider: 'none',
	},
	{
		id: 'x',
		name: 'X',
		Icon: SOCIAL_PLATFORM_ICONS.X,
		src: '/qr-code-generator/social-networks/x.svg',
		provider: 'none',
	},
	{
		id: 'whatsapp',
		name: 'WhatsApp',
		Icon: SOCIAL_PLATFORM_ICONS.Whatsapp,
		src: '/qr-code-generator/social-networks/whatsapp.svg',
		provider: 'none',
	},
	{
		id: 'tiktok',
		name: 'TikTok',
		Icon: SOCIAL_PLATFORM_ICONS.Tiktok,
		src: '/qr-code-generator/social-networks/tiktok.svg',
		provider: 'none',
	},
	{
		id: 'snapchat',
		name: 'Snapchat',
		Icon: SOCIAL_PLATFORM_ICONS.Snapchat,
		src: '/qr-code-generator/social-networks/snapchat.svg',
		provider: 'none',
	},
	{
		id: 'youtube',
		name: 'YouTube',
		Icon: SOCIAL_PLATFORM_ICONS.Youtube,
		src: '/qr-code-generator/social-networks/youtube.svg',
		provider: 'none',
	},
	{
		id: 'telegram',
		name: 'Telegram',
		Icon: SOCIAL_PLATFORM_ICONS.Telegram,
		src: '/qr-code-generator/social-networks/telegram.svg',
		provider: 'none',
	},
	{
		id: 'messenger',
		name: 'Messenger',
		Icon: SOCIAL_PLATFORM_ICONS.Messenger,
		src: '/qr-code-generator/social-networks/messenger.svg',
		provider: 'none',
	},
	{
		id: 'yelp',
		name: 'Yelp',
		Icon: SOCIAL_PLATFORM_ICONS.Yelp,
		src: '/qr-code-generator/social-networks/yelp.svg',
		provider: 'none',
	},
	{
		id: 'google-reviews',
		name: 'Google Reviews',
		Icon: SOCIAL_PLATFORM_ICONS.GoogleReviews,
		src: '/qr-code-generator/social-networks/google-reviews.svg',
		provider: 'none',
	},
	{
		id: 'pinterest',
		name: 'Pinterest',
		Icon: SOCIAL_PLATFORM_ICONS.Pinterest,
		src: '/qr-code-generator/social-networks/pinterest.svg',
		provider: 'none',
	},
	{
		id: 'linkedin',
		name: 'Linkedin',
		Icon: SOCIAL_PLATFORM_ICONS.Linkedin,
		src: '/qr-code-generator/social-networks/linkedin.svg',
		provider: 'none',
	},
	{
		id: 'xing',
		name: 'Xing',
		Icon: SOCIAL_PLATFORM_ICONS.Xing,
		src: '/qr-code-generator/social-networks/xing.svg',
		provider: 'none',
	},
	{
		id: 'dribbble',
		name: 'Dribbble',
		Icon: SOCIAL_PLATFORM_ICONS.Dribbble,
		src: '/qr-code-generator/social-networks/dribbble.svg',
		provider: 'none',
	},
	{
		id: 'tripadvisor',
		name: 'TripAdvisor',
		Icon: SOCIAL_PLATFORM_ICONS.TripAdvisor,
		src: '/qr-code-generator/social-networks/trip-advisor.svg',
		provider: 'none',
	},
	{
		id: 'line',
		name: 'Line',
		Icon: SOCIAL_PLATFORM_ICONS.Line,
		src: '/qr-code-generator/social-networks/line.svg',
		provider: 'none',
	},
	{
		id: 'reddit',
		name: 'Reddit',
		Icon: SOCIAL_PLATFORM_ICONS.Reddit,
		src: '/qr-code-generator/social-networks/reddit.svg',
		provider: 'none',
	},
	{
		id: 'viber',
		name: 'Viber',
		Icon: SOCIAL_PLATFORM_ICONS.Viber,
		src: '/qr-code-generator/social-networks/viber.svg',
		provider: 'none',
	},
	{
		id: 'tumblr',
		name: 'Tumblr',
		Icon: SOCIAL_PLATFORM_ICONS.Tumblr,
		src: '/qr-code-generator/social-networks/tumblr.svg',
		provider: 'none',
	},
	{
		id: 'github',
		name: 'GitHub',
		Icon: SOCIAL_PLATFORM_ICONS.Github,
		src: '/qr-code-generator/social-networks/github.svg',
		provider: 'none',
	},
	{
		id: 'doordash',
		name: 'DoorDash',
		Icon: SOCIAL_PLATFORM_ICONS.Doordash,
		src: '/qr-code-generator/social-networks/doordash.svg',
		provider: 'none',
	},
	{
		id: 'vk',
		name: 'VK',
		Icon: SOCIAL_PLATFORM_ICONS.Vk,
		src: '/qr-code-generator/social-networks/vk.svg',
		provider: 'none',
	},
	{
		id: 'signal',
		name: 'Signal',
		Icon: SOCIAL_PLATFORM_ICONS.Signal,
		src: '/qr-code-generator/social-networks/signal.svg',
		provider: 'none',
	},
	{
		id: 'outlook',
		name: 'Outlook',
		Icon: SOCIAL_PLATFORM_ICONS.Outlook,
		src: '/qr-code-generator/social-networks/outlook.svg',
		provider: 'none',
	},
	{
		id: 'apple',
		name: 'Apple',
		Icon: SOCIAL_PLATFORM_ICONS.Apple,
		src: '/qr-code-generator/social-networks/apple.svg',
		provider: 'none',
	},
	{
		id: 'gmail',
		name: 'Gmail',
		Icon: SOCIAL_PLATFORM_ICONS.Gmail,
		src: '/qr-code-generator/social-networks/gmail.svg',
		provider: 'none',
	},
	{
		id: 'netflix',
		name: 'Netflix',
		Icon: SOCIAL_PLATFORM_ICONS.Netflix,
		src: '/qr-code-generator/social-networks/netflix.svg',
		provider: 'none',
	},
	{
		id: 'web',
		name: 'Web',
		Icon: SOCIAL_PLATFORM_ICONS.Web,
		src: '/qr-code-generator/social-networks/web.svg',
		provider: 'none',
	},
] as const

export type TSocialPlatform = keyof typeof SOCIAL_PLATFORM_ICONS
